import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { IngredientsServices } from "../../ingredients/services";
import { ProductsServices } from "../../products/services";
import { StockServices } from "../services";
import { ProvidersServices } from "../../providers/services";
import { TranslateService } from '@ngx-translate/core';
import { AdsServices } from '../../ads/services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { StockListPage } from '../stock-list/stock-list';
import { AnalyticsServices } from '../../services/analyticsServices';
import { StaticsServices } from '../../services/statics';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-list-update-inventory',
  templateUrl: 'stock-list-update-inventory.html',
})


export class StockListUpdateInventoryPage {


  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'price', dir: 'asc' },
    { prop: 'min', dir: 'asc' },
    { prop: 'max', dir: 'asc' },
    { prop: 'stock', dir: 'asc' },


  ];

  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  ingredient_list: boolean = true;
  reason: any;
  reason_desc: any;
  array_IngProduct_tmp = []
  editing = {};
  reasonsList = [
    { value: this.translate.instant('general-mal-estado'), label: this.translate.instant('general-mal-estado') },
    { value: this.translate.instant('general-cantidad-stock-mas-baja'), label: this.translate.instant('general-cantidad-stock-mas-baja') },
    { value: this.translate.instant('general-compra-elementos'), label: this.translate.instant('general-compra-elementos') },
    { value: this.translate.instant('general-uso-elementos-en-receta'), label: this.translate.instant('general-uso-elementos-en-receta') },
    { value: this.translate.instant('general-otros'), label: this.translate.instant('general-otros') }
  ];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public productsServices: ProductsServices,
    public providersServices: ProvidersServices,
    public stockServices: StockServices,
    public globals: Globals,
    public translate: TranslateService,
    public adsServices: AdsServices,
    public analyticsService: AnalyticsServices,
    public staticsServices: StaticsServices) {
    this.getIngProd();
  }

  async getIngProd() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-stock')
    });
    loadingPopup.present();
    //Get ingredients and products
    this.stockServices.getIngProd(true);
    loadingPopup.dismiss();
  }

  setNewStock(value, i) {
    this.stockServices.ingprod_array_filtered[i].new_stock = parseFloat(value);
    this.stockServices.ingprod_updateinventory = this.stockServices.ingprod_array_filtered
  }

  setNewReason(value: string, i: number) {
    this.stockServices.ingprod_array_filtered[i].reason = value;
    this.stockServices.ingprod_updateinventory = this.stockServices.ingprod_array_filtered;
  }

  updateValue(event, cell, rowIndex) {
    this.setNewStock(event.target.value, rowIndex)
  }

  onSort(event) {

    var _array = this.stockServices.ingprod_array_filtered;

    switch (event.column.name) {

      case 'name':

        if (event.newValue == 'asc') {
          _array.sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));
        } else {
          _array.sort((a, b) => this.globals.nameLangSelectProduct(b).localeCompare(this.globals.nameLangSelectProduct(a)));
        }
        break;
      case 'price':

        if (event.newValue == 'asc') {
          _array.sort((a, b) => a.price_static - b.price_static);
        } else {
          _array.sort((a, b) => b.price_static - a.price_static);
        }
        break;
      case 'min':

        if (event.newValue == 'asc') {
          _array.sort((a, b) => a.stock_alert - b.stock_alert);
        } else {
          _array.sort((a, b) => b.stock_alert - a.stock_alert);
        }
        break;
      case 'max':

        if (event.newValue == 'asc') {
          _array.sort((a, b) => a.stock_max - b.stock_max);
        } else {
          _array.sort((a, b) => b.stock_max - a.stock_max);
        }
        break;

      case 'stock':

        if (event.newValue == 'asc') {
          _array.sort((a, b) => a.stock - b.stock);
        } else {
          _array.sort((a, b) => b.stock - a.stock);
        }
        break;
    }

    this.stockServices.ingprod_array_filtered = _array;
  }


  updateStock() {
    //para saber si activar statics o no
    var updated = false;
    //recorremos todos los elementos
    for (let element of this.stockServices.ingprod_updateinventory) {
      //miramos que tenga stock y hacemos update por tipo de elemento
      if (element.new_stock) {//tiene introducido el nuevo stock
        //iniciamos variables de reason (por defecto otros)
        var reason = "Otros";
        if (element.reason) {//mirar si han añadido reason
          reason = element.reason;
        }
        //actualizar stock en firestore
        if (element.type == 'ingredient') {//ingredient
          this.updateIngredient(element.UID, element.new_stock);
          this.sendDataChangeStock('ingredient_stock', element.name, element.new_stock, element.stock_alert, element.stock_max, reason);
          this.sendStockAnalytics(element, reason);
          updated = true;
        } else {//product
          this.updateProduct(element.UID, element.new_stock);
          this.sendDataChangeStock('product_stock', element.name, element.new_stock, element.stock_alert, element.stock_max, reason);
          this.sendStockAnalytics(element, reason);
          updated = true;
        }
        this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], element.UID);
      }
    }
    //lanzamos el statics en caso de hacer alguna update
    if (updated) {
      this.staticsServices.changeStateStaticWait(true);
    }
    //volver a stock
    this.globals.side_menu_active = 'stock';
    this.navCtrl.setRoot(StockListPage, { refreshData: true });
  }

  updateIngredient(ingredient_uid, new_stock) {
    this.ingredientServices.afs.collection('ingredients').doc(ingredient_uid).update({
      'stock': new_stock,
      'updated_at': new Date(),
    }).then(() => { });
  }

  updateProduct(product_uid, new_stock) {
    this.productsServices.afs.collection('products').doc(product_uid).update({
      'stock': new_stock,
      'updated_at': new Date(),
    }).then(() => { });
  }

  sendDataChangeStock(element_stock, element_name, stock, stock_alert, stock_max, reason) {
    var extra = {
      "stock": stock,
      "min_stock": stock_alert,
      "max_stock": stock_max,
      "reason": reason,
      "reason_desc": "",
    };
    this.globals.dataSet(element_stock, element_name, '', JSON.stringify(extra));
  }

  async sendStockAnalytics(element, reason) {
    try {
      var stock = {
        "elements": [{
          "uid_element": element.UID,
          "name": element.name,
          "price": Math.abs(element.price_static * (element.new_stock - element.stock)), //Siempre numero positivo
          "quantity": (element.new_stock - element.stock),
          "measurement": element.measurement,
          "modifier": "",
        }],
        "uid": this.globals.restaurant_uid,
        "date": new Date(),
        "type": "stock",
        "comment": reason + " - " + this.globals.restaurant.name,
        "type_type": "MANUAL",
        "delivery_uid": null
      };
      this.analyticsService.sendStock(stock);
    } catch (error) {
      //do nothing
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/stock/stock-list-update-inventory/stock-list-update-inventory.ts